<template>
  <div class="w-full absolute flex flex-col" key="base">
    <a class="header__link drawer-menu__item header__link--primary" href="#" @click="back">
      <i class="icon text-center fal fa-arrow-left"></i>
      <span>Voltar</span>
    </a>
    <slot />
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$emit('back')
    }
  }
}
</script>
